export class GraficoDto<T> {
  label: T;
  valores: number[];
  quantidades: number[];
}
